/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {personalizedAdsToggle} from '../api'

export const useMutationPersonalizedAdsToggle = createReactQueryMutationHook('personalizedAdsToggle', personalizedAdsToggle)
